const textSize = ['xs', 'sm', 'md', 'lg'] as const;

export type TextSizeType = typeof textSize[number];

export interface TextInterface {
    /**
     * font-size
     */
    fs: number,

    /**
     * line-height
     */
    lh: number,
}

export interface ResponsiveTextInterface {
    mobile: TextInterface,
    desktop: TextInterface,
}

export interface TextThemeInterface {
    xs: TextInterface,
    sm: TextInterface,
    md: TextInterface,
    lg: TextInterface,
    subtitle: ResponsiveTextInterface,
}

const themeText: TextThemeInterface = {
    xs: { fs: 10, lh: 14 },
    sm: { fs: 12, lh: 16 },
    md: { fs: 14, lh: 20 },
    lg: { fs: 16, lh: 24 },
    subtitle: {
        mobile: { fs: 18, lh: 24 },
        desktop: { fs: 20, lh: 28 },
    },
};

export default themeText;
